import { render, staticRenderFns } from "./NodeTitlebar.vue?vue&type=template&id=d781cf2a&"
import script from "./NodeTitlebar.vue?vue&type=script&lang=ts&"
export * from "./NodeTitlebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports